import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { OrderService } from '@app/services/order/order.service';
import moment from 'moment';

@Component({
  selector: 'app-scheduledialog',
  templateUrl: './scheduledialog.component.html',
  styleUrls: ['./scheduledialog.component.scss'],
  standalone: false,
})
export class ScheduledialogComponent implements OnInit {
  lastTimeSnoozed;
  isLoading = false;
  dateTimeForm: UntypedFormGroup;
  timeUnits;
  minDate = new Date();
  timeError;
  constructor(
    public dialogRef: MatDialogRef<ScheduledialogComponent>,
    @Inject(MAT_DIALOG_DATA) public selectedOrders: any,
    private orderService: OrderService,
  ) {}
  ngOnInit(): void {
    this.lastTimeSnoozed = moment(new Date()).add(1, 'hours');
    const time = this.lastTimeSnoozed.format('hh:mm A').split(' ');
    const hourAndMinute = time[0].split(':');
    this.dateTimeForm = new UntypedFormGroup({
      hour: new UntypedFormControl(this.formatNumber(hourAndMinute[0]), [
        Validators.required,
        Validators.min(1),
        Validators.max(12),
      ]),
      minutes: new UntypedFormControl(this.formatNumber(hourAndMinute[1]), [
        Validators.required,
        Validators.min(0),
        Validators.max(59),
      ]),
      timeUnit: new UntypedFormControl(time[1], Validators.required),
    });
    this.timeUnits = [
      {
        label: 'AM',
        value: 'AM',
      },
      {
        label: 'PM',
        value: 'PM',
      },
    ];
  }

  formatNumber(number) {
    return number.toString().length === 1 ? `0${number}` : number > 9 ? +number : number;
  }

  scheduleOrders() {
    if (this.dateTimeForm.valid && this.lastTimeSnoozed) {
      const time = new Date(this.lastTimeSnoozed);
      let hours = Math.floor(this.dateTimeForm.value.hour);
      if (this.dateTimeForm.value.timeUnit === 'PM') {
        hours += 12;
      } else if (hours === 12) {
        hours = 0;
      }
      time.setHours(hours);
      time.setMinutes(this.dateTimeForm.value.minutes);
      if (new Date() > time) {
        this.timeError = 'Invalid time';
        return;
      }
      this.isLoading = true;
      this.orderService.scheduleOrders(this.selectedOrders, time).then(() => {
        this.isLoading = false;
        this.dialogRef.close();
      });
    }
  }

  close() {
    if (!this.isLoading) {
      this.dialogRef.close();
    }
  }
}
